import React, { useState } from "react"
import styled, { css } from "styled-components"
import { useForm, Controller } from "react-hook-form"
import Cleave from "cleave.js/react"
import { animateScroll as scroll } from "react-scroll"

import "cleave.js/dist/addons/cleave-phone.us"

import FormSteps from "./form-steps"
import ChevronOpen from "@images/contact/chevron_open.svg"
import ChevronLeft from "@images/contact/chevron-left.svg"
import useWindowSize from "@hooks/use-window-size"

import * as emailjs from "emailjs-com"

const size = {
  tablet: 950,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const above = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const FormWrapper = styled.div`
  input {
    padding: 22px 12px;
    border-radius: 4px;
    border: 0.5px solid var(--grey);
    width: 100%;
    display: block;
    margin-bottom: 24px;
    transition: 0.3s ease-in-out;
    font-size: 16px;
    line-height: 20px;
    color: #5c6b7e;

    &:focus {
      border: 1px solid var(--pacific-blue);
    }
    &:hover {
      border: 1px solid var(--alt-black);
    }

    ::placeholder {
      color: #5c6b7e;
      opacity: 1;
      transition: 0.3s ease-in-out;
    }

    &.errors {
      border-color: #eb5757 !important;
    }

    &:focus ~ label {
      opacity: 1;
    }
  }
  /* Remove arrows from number input */
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  .last-field {
    input {
      margin-bottom: 64px;
      ${below.mobile`
      margin-bottom: 48px;
      `}
    }
  }
  /* button {
    background: var(--pacific-blue);
    border: none;
    outline: none;
    cursor: pointer;
    padding: 12px 40px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #ffffff;

    &.disabled {
      pointer-events: none;
      background-color: transparent;
      border: 1px solid #edf2f7;
      color: #edf2f7;
    }

    &:hover {
      background: #0b395b;
    }
  } */

  hr {
    border-bottom: 1px solid #e2e8f0;
    margin-bottom: 24px;
  }
`
const Rosie = styled.input`
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  z-index: -1;
`
const ContactInfoGroup = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column-reverse;
  label:focus-within {
    opacity: 1;
  }
  input:focus::placeholder {
    color: transparent;
  }
  input:focus {
    color: var(--alt-black);
    padding: 34px 12px 10px;
  }
  label,
  input {
    transition: all 0.2s;
  }
  label {
    font-size: 14px;
    line-height: 16px;
    color: var(--grey);
    transform: translate(12px, 26px);
    opacity: 0;
  }
`
const ErrorMessage = styled.div`
  /* position: absolute; */
  font-size: 12px;
  line-height: 16px;
  transform: translateY(-22px);
  color: #eb5757;
  &.last-message {
    transform: translateY(-42px);
    ${below.mobile`
        transform: translateY(-44px);

    `}
  }
  &.select-error {
    transform: translateY(2px);
  }
  ${below.mobile`
  max-width: 270px;
  transform: translateY(-20px);
  `}
`

const FlexRowContainer = styled.div`
  display: flex;
`

const InputErrorContainer = styled.div`
  margin-right: 32px;
  width: 100%;
  &:last-of-type {
    margin-right: 0;
  }
`

const PaymentsHeader = styled.div`
  h2 {
    font-family: "Playfair Display";
    font-weight: 400;
    font-size: 36px;
    line-height: 44px;
    margin-bottom: 8px;
    color: var(--alt-black);
    ${above.mobile`
    font-size:44px;
    line-height:60px;
    text-align:center;
    `}
  }
  p {
    font-size: 20px;
    line-height: 28px;
    color: var(--alt-black);
  }

  a {
    color: var(--pacific-blue);
  }
`

const StepHeader = styled.div`
  margin: 64px 0 24px;
  h3 {
    font-family: "Averta PE", sans-serif;
    font-weight: 600;
    font-size: 28px;
    line-height: 36px;
    margin-bottom: 8px;
    color: var(--alt-black);
    ${above.mobile`
    font-size:36px;
    line-height:44px;
    `}
  }
  p {
    font-size: 20px;
    line-height: 28px;
    color: var(--alt-black);
    margin-bottom: 0;
  }
`

const StepOneInputs = styled.div`
  display: ${props => (props.step === "one" ? "block" : "none")};
  .name {
    ${above.mobile`
    width:calc(50% - 16px);
    `}
  }
`
const PNEMFlexContainer = styled.div`
  ${above.mobile`
  width:100%;
display:flex;
.phone-number {
    margin-right:16px;
}

`}
`

const ContinueButton = styled.div`
  padding: 12px 0;
  text-align: center;
  width: 100%;
  background: var(--pacific-blue);
  color: white;
  border: none;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;

  ${above.mobile`
  max-width:145px;
  `}
  &.disabled {
    pointer-events: none;
    color: #e2e8f0;
    background: var(--ice-grey);
    border: none;
  }
`

const PreviousStepButton = styled.div`
  display: flex;
  align-items: center;
  background: transparent;
  width: 100px;
  border: none;
  cursor: pointer;
  color: var(--grey);
  font-size: 14px;
  line-height: 16px;
  font-weight: 600;
  margin: 40px 0 16px;
`

const StepTwoInputs = styled.div`
  display: ${props => (props.step === "two" ? "block" : "none")};

  .step-two-header {
    margin-top: 0;
  }

  .loan-number {
    ${above.mobile`
    max-width:calc(50% - 16px);
    `}
  }

  .property-street-address {
    ${above.mobile`
    max-width: 80%;
    `}
  }
`

const SelectContainer = styled.div`
  display: flex;
  flex-flow: column-reverse;
  label:focus-within {
    opacity: 1;
  }
  input:focus::placeholder {
    color: transparent;
  }
  input:focus {
    color: var(--alt-black);
  }
  label,
  input {
    transition: all 0.2s;
  }
  label {
    font-size: 14px;
    line-height: 16px;
    color: var(--grey);
    transform: translate(14px, 21px);
    opacity: 0;
  }

  select {
    appearance: none;
    outline: none;
    padding: 22px 12px;
    border: 0.5px solid var(--grey);
    border-radius: 4px;
    width: 100%;
    color: #5c6b7e;
    font-size: 16px;
    line-height: 20px;
    background-image: url(${ChevronOpen});
    background-position: 90% center;
    background-repeat: no-repeat;
    background-size: 10px 5px;

    &.errors {
      border-color: #eb5757 !important;
    }
  }
`

const StepThreeInputs = styled.div`
  display: ${props => (props.step === "three" ? "block" : "none")};
  .step-three-header {
    margin-top: 16px;
  }
  textarea {
    width: 100%;
    border: 0.5px solid var(--grey);
    border-radius: 4px;
    font-size: 16px;
    line-height: 20px;
    color: #5c6b7e;
    padding: 12px;
    margin-bottom: 48px;

    &.errors {
      border-color: #eb5757 !important;
    }
    ${above.mobile`
    margin-bottom:64px;
    `}

    ${above.tablet`
    max-width:540px;
    `}
  }

  .message-error {
    transform: translateY(-52px);
    ${above.mobile`
        transform:translateY(-68px);

    `};
  }

  hr {
    border-bottom: 1px solid #e2e8f0;
    margin-bottom: 24px;
  }
  button {
    padding: 12px 0;
    text-align: center;
    width: 100%;
    background: var(--pacific-blue);
    color: white;
    border: none;
    font-size: 16px;
    line-height: 20px;
    cursor: pointer;

    ${above.mobile`
  max-width:145px;
  `}

    &.disabled {
      pointer-events: none;
      color: #e2e8f0;
      background: var(--ice-grey);
      border: none;
    }
  }
`

const TabletFlexContainer = styled.div`
  ${above.mobile`
display:flex;
.city {
  flex:1;
}
.state-zip {
  flex:2;
}
`}
`
const PaymentsForm = props => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, dirtyFields },
    watch,
  } = useForm({
    mode: "onTouched",
  })
  const watchAllFields = watch()
  const [step, setStep] = useState("one")
  const [stepOneCompleted, setStepOneCompleted] = useState(false)
  const [stepTwoCompleted, setStepTwoCompleted] = useState(false)

  const windowSize = useWindowSize()

  const onSubmit = data => {
    const templateParams = {
      name: data.name,
      phone: data.phone,
      email: data.email,
      borrower_name: data.borrower_name,
      co_borrower_name:
        data.co_borrower_name === "" ? "None provided" : data.co_borrower_name,
      loan_number: data.loan_number === "" ? "None Provided" : data.loan_number,
      property_street_address: data.property_street_address,
      city: data.city,
      state: data.state,
      zip: data.zip,
      send_to_email:
        data.name === "test" || data.email === "test@test.com"
          ? "webteam@atlanticbay.com"
          : "servicing@atlanticbay.com",
      message: data.message,
    }

    if (!data.pass) {
      emailjs
        .send(
          "default_service",
          "mortgage_payment",
          templateParams,
          "user_rZnp1QjHFiOah6cAnsph7",
        )
        .then(
          function (response) {},
          function (err) {},
        )
      props.setPaymentsFormSubmitted(true)
      window && window.scrollTo(0, 0)
    } else {
      props.setPaymentsFormSubmitted(true)
      window && window.scrollTo(0, 0)
    }
  }

  return (
    <FormWrapper>
      <form
        name="payments-contact-form"
        method="post"
        onSubmit={handleSubmit(onSubmit)}
      >
        <PaymentsHeader>
          <h2>Atlantic Bay Mortgage Payments</h2>
          <p>
            You can check where your mortgage payments should go using the{" "}
            <a href="/payments/">mortgage payment tool</a>. If you have any
            other questions, please submit them via the form below.
          </p>
        </PaymentsHeader>
        <FormSteps
          errors={errors}
          watchAllFields={watchAllFields}
          dirtyFields={dirtyFields}
          step={step}
          stepOneCompleted={stepOneCompleted}
          stepTwoCompleted={stepTwoCompleted}
          setStep={setStep}
          setStepOneCompleted={setStepOneCompleted}
          setStepTwoCompleted={setStepTwoCompleted}
        />

        <StepOneInputs step={step}>
          <StepHeader>
            <h3>Let us know who you are.</h3>
            <p>This information will help us reach back out to you.</p>
          </StepHeader>
          {/* Name */}
          <ContactInfoGroup className="name">
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Your name"
              defaultValue=""
              {...register("name", { required: true, minLength: 2 })}
              className={errors.name ? "errors" : undefined}
            />
            <label htmlFor="name">Your name</label>
          </ContactInfoGroup>
          {errors.name && (
            <ErrorMessage>Please enter your full name.</ErrorMessage>
          )}
          <PNEMFlexContainer>
            {/* Phone Number */}
            <InputErrorContainer>
              <ContactInfoGroup className="phone-number">
                <Controller
                  control={control}
                  rules={{ required: true, minLength: 12 }}
                  type="text"
                  name="phone"
                  id="phone"
                  defaultValue=""
                  className={errors.phone ? "errors" : undefined}
                  render={({ field }) => (
                    <Cleave
                      options={{
                        phone: true,
                        phoneRegionCode: "us",
                        delimiter: "-",
                      }}
                      placeholder="Your phone number"
                      {...field}
                    />
                  )}
                />
                <label htmlFor="phone">Your phone number</label>
              </ContactInfoGroup>
              {errors.phone && (
                <ErrorMessage>
                  Please enter a valid phone number with the area code.
                </ErrorMessage>
              )}
            </InputErrorContainer>
            {/* Email */}
            <InputErrorContainer>
              <ContactInfoGroup>
                <input
                  type="text"
                  name="email"
                  id="email"
                  placeholder="Your email"
                  defaultValue=""
                  {...register("email", {
                    required: true,
                    pattern:
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  })}
                  className={errors.email ? "errors" : undefined}
                />
                <label htmlFor="email">Your email</label>
              </ContactInfoGroup>
              {errors.email && (
                <ErrorMessage>
                  Oh, no! That doesn’t look like an email address. Could you try
                  again?
                </ErrorMessage>
              )}
            </InputErrorContainer>
          </PNEMFlexContainer>
          <hr />
          <ContinueButton
            className={
              Object.keys(errors).length === 0 &&
              watchAllFields.email &&
              watchAllFields.name &&
              watchAllFields.phone
                ? null
                : "disabled"
            }
            onClick={() => {
              setStep("two")
              setStepOneCompleted(true)
            }}
          >
            Continue
          </ContinueButton>
        </StepOneInputs>

        <StepTwoInputs step={step}>
          <PreviousStepButton onClick={() => setStep("one")}>
            <img src={ChevronLeft} alt="chevron left icon" />
            {"Previous step"}
          </PreviousStepButton>
          <StepHeader className="step-two-header">
            <h3>Loan information</h3>
            <p>
              Providing this information will allow us to get more insight on
              any issues you may have experienced.
            </p>
          </StepHeader>
          <TabletFlexContainer>
            <InputErrorContainer>
              {/* Borrower's Name */}
              <ContactInfoGroup>
                <input
                  type="text"
                  name="borrower_name"
                  id="borrower_name"
                  placeholder="Borrower's name"
                  defaultValue=""
                  {...register("borrower_name", {
                    required: true,
                    minLength: 2,
                  })}
                  className={errors.borrower_name ? "errors" : undefined}
                />
                <label htmlFor="borrower_name">Borrower's name</label>
              </ContactInfoGroup>
              {errors.borrower_name && (
                <ErrorMessage>
                  Please enter your full borrower name.
                </ErrorMessage>
              )}
            </InputErrorContainer>
            <InputErrorContainer>
              {/* Co-Borrower's Name */}
              <ContactInfoGroup>
                <input
                  type="text"
                  name="co_borrower_name"
                  id="co_borrower_name"
                  placeholder="Co-Borrower's name (optional)"
                  defaultValue=""
                  {...register("co_borrower_name", { minLength: 2 })}
                  className={errors.co_borrower_name ? "errors" : undefined}
                />
                <label htmlFor="co_borrower_name">
                  Co-Borrower's name (optional)
                </label>
              </ContactInfoGroup>
              {errors.co_borrower_name && (
                <ErrorMessage>
                  Almost there! Please enter your full co-borrower name.
                </ErrorMessage>
              )}
            </InputErrorContainer>
          </TabletFlexContainer>
          {/* Loan Number */}
          <ContactInfoGroup className="loan-number">
            <input
              type="text"
              name="loan_number"
              id="loan_number"
              placeholder="Loan number (optional)"
              defaultValue=""
              {...register("loan_number")}
              className={errors.loan_number ? "errors" : undefined}
            />
            <label htmlFor="loan_number">Loan number (optional)</label>
          </ContactInfoGroup>
          {errors.loan_number && (
            <ErrorMessage>
              Almost there! Please enter a complete loan number.
            </ErrorMessage>
          )}
          {/* Property Street Address */}
          <ContactInfoGroup className="property-street-address">
            <input
              type="text"
              name="property_street_address"
              id="property_street_address"
              placeholder="Property Street Address"
              defaultValue=""
              {...register("property_street_address", {
                required: true,
                minLength: 2,
              })}
              className={errors.property_street_address ? "errors" : undefined}
            />
            <label htmlFor="property_street_address">
              Property Street Address
            </label>
          </ContactInfoGroup>
          {errors.property_street_address && (
            <ErrorMessage>
              Please enter a complete property address.
            </ErrorMessage>
          )}
          {/* Property City */}
          <TabletFlexContainer>
            <InputErrorContainer className="city">
              <ContactInfoGroup>
                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  defaultValue=""
                  {...register("city", { required: true, minLength: 2 })}
                  className={errors.city ? "errors" : undefined}
                />
                <label htmlFor="city">City</label>
              </ContactInfoGroup>

              {errors.city && (
                <ErrorMessage>Please enter a complete city.</ErrorMessage>
              )}
            </InputErrorContainer>
            <FlexRowContainer className="state-zip">
              {/* State */}
              <InputErrorContainer>
                <SelectContainer>
                  <select
                    name="state"
                    id="state"
                    {...register("state", {
                      required: true,
                      validate: value => value !== "placeholder",
                    })}
                    className={errors.state ? "errors" : undefined}
                  >
                    <option value="" defaultValue>
                      State
                    </option>
                    <option value="AL">AL</option>
                    <option value="DC">DC</option>
                    <option value="DE">DE</option>
                    <option value="FL">FL</option>
                    <option value="GA">GA</option>
                    <option value="IN">IN</option>
                    <option value="KY">KY</option>
                    <option value="MD">MD</option>
                    <option value="MS">MS</option>
                    <option value="NC">NC</option>
                    <option value="NJ">NJ</option>
                    <option value="PA">PA</option>
                    <option value="SC">SC</option>
                    <option value="TN">TN</option>
                    <option value="TX">TX</option>
                    <option value="VA">VA</option>
                    <option value="WV">WV</option>
                  </select>
                  <label htmlFor="state">State</label>
                </SelectContainer>
                {errors.state && (
                  <ErrorMessage className="select-error">
                    Please make a selection.
                  </ErrorMessage>
                )}
              </InputErrorContainer>
              {/* Zip */}
              <InputErrorContainer>
                <ContactInfoGroup>
                  <input
                    type="number"
                    name="zip"
                    id="zip"
                    placeholder="Zip Code"
                    defaultValue=""
                    {...register("zip", {
                      required: true,
                      minLength: 5,
                      maxLength: 5,
                    })}
                    className={errors.zip ? "errors" : undefined}
                  />
                  <label htmlFor="zip">Zip Code</label>
                </ContactInfoGroup>
                {errors.zip && (
                  <ErrorMessage>Please enter a valid zip code.</ErrorMessage>
                )}
              </InputErrorContainer>
            </FlexRowContainer>
          </TabletFlexContainer>
          <hr />
          <ContinueButton
            className={
              Object.keys(errors).length === 0 &&
              watchAllFields.email &&
              watchAllFields.name &&
              watchAllFields.phone &&
              watchAllFields.borrower_name &&
              watchAllFields.property_street_address &&
              watchAllFields.city &&
              watchAllFields.state &&
              watchAllFields.zip
                ? null
                : "disabled"
            }
            onClick={() => {
              setStep("three")
              setStepTwoCompleted(true)
              if (windowSize.height < 1000) {
                scroll.scrollTo(694, {
                  delay: 0,
                  smooth: true,
                })
              }
            }}
          >
            Continue
          </ContinueButton>
        </StepTwoInputs>
        <StepThreeInputs step={step}>
          <PreviousStepButton onClick={() => setStep("two")}>
            <img src={ChevronLeft} alt="chevron left icon" />
            {"Previous step"}
          </PreviousStepButton>
          <StepHeader className="step-three-header">
            <h3>Your message</h3>
            <p>Please provide as many details as you can.</p>
          </StepHeader>
          <textarea
            name="message"
            id="message"
            cols="30"
            rows="5"
            placeholder="Type your message here"
            className={errors.message ? "errors" : undefined}
            {...register("message", { required: true, minLength: 2 })}
          ></textarea>
          {errors.message && (
            <ErrorMessage className="message-error">
              Please enter a longer message.
            </ErrorMessage>
          )}
          <div>
            <Rosie
              title="pass"
              name="pass"
              autoComplete="off"
              tabIndex="-1"
              {...register("pass")}
            />
          </div>
          <hr />
          <button
            type="submit"
            className={
              Object.keys(errors).length === 0 &&
              watchAllFields.email &&
              watchAllFields.name &&
              watchAllFields.phone &&
              watchAllFields.borrower_name &&
              watchAllFields.property_street_address &&
              watchAllFields.city &&
              watchAllFields.state &&
              watchAllFields.zip &&
              watchAllFields.message
                ? null
                : "disabled"
            }
          >
            Send message
          </button>
        </StepThreeInputs>
      </form>
    </FormWrapper>
  )
}

export default PaymentsForm
